@if (definition.disableable && configOption.id) {
  <mat-slide-toggle
    class="mt-2"
    [color]="'primary'"
    [(ngModel)]="enabled"
    [disableRipple]="true"
    (change)="onEnableChange($event)"
  />
}
